export default class Answer {
    constructor(text, value) {
        this.text = text;
        this.value = value;
    }
}